import { getStsToken } from "@/api/oss";
import COS from 'cos-js-sdk-v5'
export const getAuthorization = (options,callback) => {
  getStsToken().then(res => {
    const {
      sessionToken,
      tmpSecretId,
      tmpSecretKey,
      startTime,
      expiredTime
    } = res.data;
    callback({
      TmpSecretId: tmpSecretId,
      TmpSecretKey: tmpSecretKey,
      XCosSecurityToken: sessionToken,
      StartTime: startTime,
      ExpiredTime: expiredTime
    });
  });
};


export const Bucket = 'chao-1253683723';
export const Region = 'ap-beijing';
const cosClient = new COS({
  getAuthorization: getAuthorization
});

export default cosClient
